var _path, _path2, _path3, _path4, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLitentry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.1668 10.4209L17.9372 9.30078L16.3345 11.0357C16.2382 11.1393 16.1195 11.2196 15.9872 11.2707C15.855 11.3218 15.7127 11.3422 15.5713 11.3305L14.2569 11.2042C14.1627 11.1942 14.0675 11.2066 13.9791 11.2403C13.8906 11.274 13.8115 11.328 13.7481 11.3979L8.76196 16.8048L9.99154 17.9165L15.6985 11.7347C15.7717 11.6542 15.8658 11.5951 15.9704 11.564C16.0751 11.5328 16.1863 11.5307 16.2921 11.5579L17.4454 11.8358C17.5512 11.8603 17.6617 11.8569 17.7659 11.8258C17.87 11.7948 17.9641 11.7373 18.0389 11.6589L19.1668 10.4209Z",
    fill: "url(#paint0_linear_5978_78153)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5297 8.01222L15.3001 6.89209L12.4509 9.98297C12.3546 10.0865 12.2358 10.1669 12.1036 10.218C11.9713 10.2691 11.8291 10.2895 11.6877 10.2777L10.3733 10.1514C10.2791 10.1415 10.1839 10.1539 10.0955 10.1875C10.007 10.2212 9.92788 10.2752 9.8645 10.3451L6.12488 14.3961L7.35446 15.5162L11.8064 10.6904C11.8796 10.6099 11.9737 10.5508 12.0783 10.5196C12.183 10.4885 12.2942 10.4863 12.4 10.5136L13.5532 10.7915C13.6591 10.816 13.7696 10.8125 13.8737 10.7815C13.9779 10.7505 14.072 10.693 14.1468 10.6146L16.5297 8.01222Z",
    fill: "url(#paint1_linear_5978_78153)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8841 5.61207L12.6545 4.49194L8.55021 8.93034C8.45396 9.03389 8.33518 9.11427 8.20293 9.16535C8.07068 9.21643 7.92843 9.23687 7.78702 9.22511L6.47264 9.09878C6.37846 9.08886 6.28325 9.10124 6.19481 9.13491C6.10637 9.16858 6.02722 9.22258 5.96385 9.29249L3.47925 11.9875L4.70883 13.1077L7.90574 9.63779C7.97897 9.55725 8.07301 9.49819 8.17766 9.46701C8.28231 9.43583 8.39356 9.43372 8.49933 9.46093L9.6526 9.73886C9.75848 9.76335 9.86896 9.75992 9.97309 9.72889C10.0772 9.69787 10.1714 9.64033 10.2462 9.56199L13.8841 5.61207Z",
    fill: "url(#paint2_linear_5978_78153)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2467 3.20338L10.0171 2.08325L4.6578 7.88602C4.56154 7.98957 4.44277 8.06994 4.31051 8.12102C4.17826 8.17211 4.03602 8.19255 3.89461 8.18079L2.58023 8.05446C2.48604 8.04453 2.39083 8.05692 2.30239 8.09059C2.21396 8.12426 2.13481 8.17826 2.07144 8.24816L0.833374 9.57884L2.06296 10.699L4.01333 8.58504C4.08655 8.50451 4.1806 8.44544 4.28525 8.41426C4.3899 8.38308 4.50115 8.38098 4.60692 8.40818L5.76018 8.68611C5.86606 8.7106 5.97655 8.70717 6.08068 8.67614C6.18481 8.64512 6.27895 8.58758 6.35377 8.50925L11.2467 3.20338Z",
    fill: "url(#paint3_linear_5978_78153)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5978_78153",
    x1: 17.944,
    y1: 9.30752,
    x2: 10.0498,
    y2: 17.9771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#02C86A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#14EA85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5978_78153",
    x1: 15.3094,
    y1: 6.90051,
    x2: 7.41445,
    y2: 15.5709,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#02C86A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#11ED85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5978_78153",
    x1: 12.6579,
    y1: 4.49531,
    x2: 4.76709,
    y2: 13.1606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#1FD17D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#2CE28C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5978_78153",
    x1: 10.0179,
    y1: 2.08409,
    x2: 2.1238,
    y2: 10.7545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#1BC675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0FD879"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLitentry);
export default __webpack_public_path__ + "static/media/litentry.da86ed4b5dfbca88701b915933e9300d.svg";
export { ForwardRef as ReactComponent };